import React from 'react';
import './styles/index.css';
import './styles/training.css';

const TrainingMenu = ({ onBack, onSelectCheckout, onSelectCheckoutDuel, onSelectX01, onSelectTopPlayers, onSelectJesusSalate, onSelectMechanics, onSelectBotGame, onSelectTriples, onSelectCricket }) => {
  return (
    <div className="dart-league-dashboard training-menu-container">
      {/* Header */}
      <header className="training-menu-header">
        <div className="training-header-top">
          <button 
            className="training-back-btn"
            onClick={onBack}
          >
            ← Volver
          </button>
        </div>
        <div className="training-header-icon">
          <img src="/Logo26.png" alt="501 Dart League" className="training-header-logo" />
        </div>
        <h1 className="training-menu-title">Entrenamientos y Partidas</h1>
        <p className="training-menu-subtitle">Practica, juega y mejora tu nivel</p>
      </header>

      {/* Training Options */}
      <main className="training-options-grid">
        {/* X01 - Partida Libre */}
        <button 
          className="training-option-card x01 active"
          onClick={onSelectX01}
        >
          <div className="training-option-icon">
            <span>🎯</span>
          </div>
          <div className="training-option-content">
            <h3>X01</h3>
            <p>Partida clásica de reducción</p>
          </div>
          <div className="training-option-arrow">→</div>
        </button>

        {/* Cricket - ACTIVO */}
        <button
          className="training-option-card cricket active"
          onClick={onSelectCricket}
        >
          <div className="training-option-icon">
            <span>🏏</span>
          </div>
          <div className="training-option-content">
            <h3>Cricket</h3>
            <p>20·19·18·17·16·15·Bull · cierra y puntúa</p>
            <span className="training-option-badge available">¡NUEVO!</span>
          </div>
          <div className="training-option-arrow">→</div>
        </button>

        {/* Vs IA */}
        <button 
          className="training-option-card bot-game active"
          onClick={onSelectBotGame}
        >
          <div className="training-option-icon">
            <span>🤖</span>
          </div>
          <div className="training-option-content">
            <h3>Vs IA</h3>
            <p>Juega contra la máquina con 8 niveles de dificultad</p>
          </div>
          <div className="training-option-arrow">→</div>
        </button>

        {/* Jugadores TOP */}
        <button 
          className="training-option-card top-players active"
          onClick={onSelectTopPlayers}
        >
          <div className="training-option-icon">
            <span>🏆</span>
          </div>
          <div className="training-option-content">
            <h3>Jugadores TOP</h3>
            <p>Elige un jugador y completa su rutina</p>
            <span className="training-option-badge available">ACTUALIZADO</span>
          </div>
          <div className="training-option-arrow">→</div>
        </button>

        {/* Entrenamiento de Cierres - ACTIVO */}
        <button 
          className="training-option-card checkouts active"
          onClick={onSelectCheckout}
        >
          <div className="training-option-icon">
            <span>🔢</span>
          </div>
          <div className="training-option-content">
            <h3>Cierres</h3>
            <p>Practica cierres de 1, 2 y 3 dardos</p>
          </div>
          <div className="training-option-arrow">→</div>
        </button>

        {/* Duelo de Triples - ACTIVO */}
        <button
          className="training-option-card triples active"
          onClick={onSelectTriples}
        >
          <div className="training-option-icon">
            <span>🎯</span>
          </div>
          <div className="training-option-content">
            <h3>Duelo de Triples</h3>
            <p>Elige triple · a 5 o a 10 · turno bonus si metes 3</p>
            <span className="training-option-badge available">¡NUEVO!</span>
          </div>
          <div className="training-option-arrow">→</div>
        </button>

        {/* Duelo de Cierres - ACTIVO */}
        <button 
          className="training-option-card checkout-duel active"
          onClick={onSelectCheckoutDuel}
        >
          <div className="training-option-icon">
            <span>🏹</span>
          </div>
          <div className="training-option-content">
            <h3>Duelo de Cierres</h3>
            <p>Individual o duelo · cierres 51-90</p>
            <span className="training-option-badge available">¡NUEVO!</span>
          </div>
          <div className="training-option-arrow">→</div>
        </button>

        {/* Analiza tu Mecánica */}
        <button 
          className="training-option-card mechanics disabled"
          disabled
        >
          <div className="training-option-icon">
            <span>📹</span>
          </div>
          <div className="training-option-content">
            <h3>Analiza tu Mecánica</h3>
            <p>Graba tu tirada y recibe un análisis técnico detallado</p>
            <span className="training-option-badge coming-soon">Próximamente</span>
          </div>
          <div className="training-option-arrow">→</div>
        </button>
      </main>

      {/* Info Section */}
      <section className="training-info-section">
        <div className="training-info-box">
          <div className="training-info-icon">💡</div>
          <div className="training-info-text">
            <strong>¿Por qué entrenar aquí?</strong>
            <p>Practica cierres, juega partidas X01, analiza tu mecánica de tiro o entrena con las rutinas de los mejores jugadores. Todo lo que necesitas para mejorar tu nivel.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TrainingMenu;
